import { toastSlice } from './toast.slice';

export const TOAST_REDUCER_KEY = toastSlice.name;
export const toastReducer = toastSlice.reducer;
